import {selectShortcuts} from "../../../redux/selectors/firebase";
import {connect} from "react-redux";
import {useContext, useEffect} from "react";
import {IShortcut} from "./Shortcuts";
import {FirebaseContext} from "../../firebase/FirebaseProvider";
import {IGraphData} from "../../../redux/slices/editor";
import {selectModeData, selectProject} from "../../../redux/selectors/editor";

interface IShortcutHandler {
    graphData: IGraphData
    project: string
    shortcuts: {[key: string]: IShortcut}
}
function ShortcutHandler({graphData, project, shortcuts}: IShortcutHandler) {
    const {push} = useContext(FirebaseContext);

    useEffect(() => {
        if (Object.keys(shortcuts).length > 0) {
            const handleKeyDown = (event: KeyboardEvent) => {
                const actions = Object.values(shortcuts)
                    .filter(shortcut => shortcut.event && shortcut.action)
                    .filter(shortcut =>
                        shortcut.event.key.toLowerCase() === event.key.toLowerCase() &&
                        shortcut.event.shiftKey === event.shiftKey &&
                        shortcut.event.altKey === event.altKey &&
                        shortcut.event.ctrlKey === event.ctrlKey)
                    .map(shortcut => shortcut.action);

                actions.forEach(action => {
                    if (action.type === "addTagToSelected") {
                        graphData.selected.forEach(state =>
                            push(`tags/${project}/${state}`, action.data)
                        )
                    }
                });
            }

            window.addEventListener("keydown", handleKeyDown);
            return () => window.removeEventListener("keydown", handleKeyDown);
        }
    }, [graphData.selected, project, push, shortcuts]);
    
    return null;
}
const mapStateToProps = (store: never) => ({
    graphData: selectModeData(store) as IGraphData,
    project: selectProject(store),
    shortcuts: selectShortcuts(store) || {}
});

const connected = connect(mapStateToProps, {
})(ShortcutHandler);
export {connected as ShortcutHandler}